// extracted by mini-css-extract-plugin
module.exports = {"link":"entity_decision_list-module__link--2dlp4"};